import { useEffect, useMemo } from 'react';

import useStore from '../../../stores/helpers/use-context';
import type { RoutesPlannerDeps } from '../../../types';
import type { UpdatingSource } from '../../types';
import useTableColumns from '../../planner-table/table-components/table-columns/use-table-columns';

const usePlannerTable = (
	deps: RoutesPlannerDeps,
	selectedTasksIds: number[],
	changeTasksSelection: (tasksIds: number[], source: UpdatingSource) => void,
	multiSelectedEnabled: boolean
) => {
	const { runToTasksInPresentedDate, runToDriver, runsToDisplay, setRunsToDisplay, tableStore, routesColors } =
		useStore();
	const { tasks: tableTasks, totalRuns, skipTablePageReset, setSkipTablePageReset, toggleRuns } = tableStore;

	useEffect(() => {
		setSkipTablePageReset(false);
	}, [runToTasksInPresentedDate]);

	const { getTableColumns } = useTableColumns();

	const columns = useMemo(
		() =>
			getTableColumns({
				deps,
				selectedTasksIds,
				changeTasksSelection,
				multiSelectedEnabled
			}),
		[routesColors, runToDriver, selectedTasksIds]
	);

	return {
		columns,
		tableTasks,
		skipTablePageReset,
		setSkipTablePageReset,
		totalRuns,
		toggleRuns,
		runsToDisplay,
		setRunsToDisplay
	};
};

export default usePlannerTable;
